import { DrawCabinetFrontElement } from "$src/CGS/domain/dto/article/Cabinet/FrontElement/DrawCabinetFrontElement";
import { DrawCabinetFrontElementGroup } from "$src/CGS/domain/dto/article/Cabinet/FrontElement/DrawCabinetFrontElementGroup";
import { EFrontElement } from "$src/CGS/domain/dto/core/EFrontElement";
import { Length } from "$src/CGS/domain/dto/core/Length/Length";
import { Vector3 } from "three";
import { FrontHandleMetadata } from "./FrontHandleMetadata";
import { FrontFaceMetadata } from "./FrontFaceMetadata";
import { InsideContainerMetadata } from "./InsideContainerMetadata";
import { LengthValueMillimeter } from "$src/CGS/domain/dto/core/Length/LengthValueMillimeter";

export abstract class FrontMetadata {
    Anchor: Vector3 = new Vector3();
    Width: Length = new LengthValueMillimeter(0);
    Height: Length = new LengthValueMillimeter(0);
    ParentGroup: FrontGroupMetadata | null = null;
    FrontFaces: FrontFaceMetadata[] = [];
    Inside?: InsideContainerMetadata;
}

export class FrontGroupMetadata extends FrontMetadata {
    ContextGroup?: DrawCabinetFrontElementGroup;
    Elements: FrontMetadata[] = [];
}

export class FrontElementMetadata extends FrontMetadata {
    Type: EFrontElement = EFrontElement.NONE;
    Context?: DrawCabinetFrontElement;
    Handles: FrontHandleMetadata[] | null = null;
}